<script>
	import BotonCaja from './../componentes/BotonCaja.svelte';
    import { breakpoint } from '../componentes/MediaQuery.svelte';
    import { moneda, object2array, postData,moneda4, redondeo4 } from "../scripts";
    import { sucursal, urlapi } from "../stores/store";
    import Pagination from './Pagination.svelte';
    export let cliente={};
    export let factura={};
    export let aplicar_descuento=false;

    let campoNIT=false;
    let countSelected=0;
    let activo=cliente.activo;

    let offcanvas=false;
    let bsOffcanvas=false;
    let offcanvasClose=false;
    let productosFavoritos=[];
    let checkButton=false;

    postData($urlapi, [{ 'cmd':'productos_listAyuda','sucursal':$sucursal}])
    .then(data => {
        productosFavoritos=object2array(data[0].result.productos)
    });    

/*    setTimeout(function(){ 
        bsOffcanvas = new bootstrap.Offcanvas(offcanvas)
        bsOffcanvas.show()
    }, 1);*/

/*    $: if(factura.carrito) {
        console.log( factura.carrito )
    }*/

    calcular()
    calcular_descuento()

    $: if(cliente.activo===true || cliente.activo===false) {
        activo=cliente.activo;
    }

    export function calcular() {

        factura.carrito.map(item=>item.total= item.cantidad*item.precio-item.descuento )
        
//console.log(redondeo4( factura.carrito[0].total) );

        //factura.carrito.map(item=>item.total= redondeo4(item.total) )

        //factura.carrito[index].total=factura.carrito[index].cantidad*factura.carrito[index].precio;

        factura.total=factura.carrito.reduce((n, {total}) => n + total, 0);

        //factura.carrito.forEach(item => { console.log(item.total); });

        let seleccionados = factura.carrito.filter(function(item){
                if (item.encontrado === true) {
                    return true;
                } else {
                    return false;
                }
        });
        factura.cantidad=seleccionados.reduce((n, {cantidad}) => n + cantidad, 0);
    }

    export function calcular_descuento() {
        
        if(aplicar_descuento===false)
        {
            let porciento=((factura.descuento*100)/factura.total)/100;
            factura.carrito.map(item=>item.descuento=redondeo4(item.total*porciento))
            factura.carrito.map(item=>item.total=redondeo4(item.total))
        } else {
            factura.carrito.map(item=>item.total=redondeo4(item.total))
        }

        calcular()
    }

    function countSelecteds() {
        countSelected = factura.carrito.filter(function(item){
                if (item.selected === true) {
                    return true;
                } else {
                    return false;
                }
            }).length;        
    }

    function selecIndex(index)
    {
        factura.carrito[index].selected=!factura.carrito[index].selected;
        countSelecteds()
    }

    function checkAll()
    {
        checkButton=!checkButton;
        
        let ncarrito = factura.carrito.filter(function(item){
                item.selected=checkButton
                return true;
        })
        factura.carrito=[...ncarrito]
        countSelecteds()
    }

    function deleteSelected()
    {
        let seleccionados = factura.carrito.filter(function(item){
                if (item.selected === true) {
                    return false;
                } else {
                    return true;
                }
        });
        factura.carrito=[...seleccionados]
        countSelected=0;
        calcular()
        calcular_descuento()
    }

    export function buscar_producto_nuevo()
    {
        let result = factura.carrito.findIndex(function(object) {
            return object.lock ===false;
        });
        if(result==-1) {
            let nuevo={ codigo:'',descripcion:'<span class="text-danger">PRODUCTO NO ASIGNADO</span>', cantidad:1,precio:0,descuento:0,total:0,selected:false,lock:false,encontrado:false,editable:'0'}
            factura.carrito=[...factura.carrito,nuevo]
        } else {
            document.getElementById('registro'+result).getElementsByTagName( 'input' )[1].focus()
            document.getElementById('registro'+result).getElementsByTagName( 'input' )[1].select()
        }
    }

    function handleKeydown(event,campo,index)
    {
        if(event.keyCode==13)
        {
            if(campo=='codigo')
            {
                
                postData($urlapi, [{ 'cmd':'productos_search', 'codigo':factura.carrito[index].codigo ,'sucursal':$sucursal }])
                .then(data => {
                    if(data[0].result===false)
                    {
                        factura.carrito[index].descripcion='<span class="text-danger">PRODUCTO NO ENCONTRADO</span>';
                        factura.carrito[index].precio=0;
                        factura.carrito[index].editable='0';
                    } else {
                        factura.carrito[index].descripcion=data[0].result.nombre;
                        factura.carrito[index].precio=data[0].result.precio;
                        factura.carrito[index].lock=true;
                        factura.carrito[index].encontrado=true;
                        factura.carrito[index].editable=data[0].result.editable;
                        changeCantidad(index)

                        if(factura.carrito[index].editable=='1')
                        {
                            event.target.parentNode.parentNode.getElementsByTagName( 'input' )[2].focus()
                            event.target.parentNode.parentNode.getElementsByTagName( 'input' )[2].select()
                        } else {
                            buscar_producto_nuevo()
                        }                        

                        //buscar_producto_nuevo()
                        //event.target.parentNode.parentNode.getElementsByTagName( 'input' )[2].focus()
                        //event.target.parentNode.parentNode.getElementsByTagName( 'input' )[2].select()
                    }
                });
                
                //factura.carrito[index].lock=true;

            } else if (campo=='cantidad') {
                if(factura.carrito[index].editable=='1')
                {
                    event.target.parentNode.parentNode.getElementsByTagName( 'input' )[2].focus()
                    event.target.parentNode.parentNode.getElementsByTagName( 'input' )[2].select()
                } else {
                    buscar_producto_nuevo()
                }
            } else if (campo=='precio') {
                buscar_producto_nuevo()
            }
            
            
        }
    }
    function changeCantidad(index)
    {
        //factura.carrito[index].total=factura.carrito[index].cantidad*factura.carrito[index].precio;
        calcular();
        calcular_descuento()
    }

    function addProductoFavorito(index)
    {
        offcanvasClose.click()
        let result = factura.carrito.findIndex(function(object) {
            return object.lock ===false;
        });
        if(result==-1) {
            let nuevo={ 
                codigo: productosFavoritos[index].codigo,
                descripcion: productosFavoritos[index].nombre,  
                cantidad:1,
                precio: productosFavoritos[index].precio,
                editable: productosFavoritos[index].editable,
                descuento:0,
                total:0,
                selected:false,
                lock:true,
                encontrado:true
            }
            factura.carrito=[...factura.carrito,nuevo]
            let indexer=factura.carrito.length-1;
            changeCantidad(indexer)
            setTimeout(() => {
                document.getElementById('registro'+indexer).getElementsByTagName( 'input' )[1].focus()
                document.getElementById('registro'+indexer).getElementsByTagName( 'input' )[1].select()
            }, 400);

        } else {
            factura.carrito[result]={ 
                codigo: productosFavoritos[index].codigo,
                descripcion: productosFavoritos[index].nombre, 
                cantidad:1,
                precio: productosFavoritos[index].precio,
                editable: productosFavoritos[index].editable,
                descuento:0,
                total:0,
                selected:false,
                lock:true,
                encontrado:true
            }

            setTimeout(() => {
                document.getElementById('registro'+result).getElementsByTagName( 'input' )[1].focus()
                document.getElementById('registro'+result).getElementsByTagName( 'input' )[1].select()
            }, 400);
            changeCantidad(result)
        }
        calcular()    
        calcular_descuento()
    }
</script>

<div class='mb-1 pe-2'>
    <button disabled={activo || factura.pagado}
        class:btn-lg={$breakpoint === 'xxl'}
        class:btn-md={$breakpoint !== 'xxl'}
        class='btn btn-warning me-1' on:click={buscar_producto_nuevo}><i class="bi bi-cursor-text"></i><i class="bi bi-plus-lg"></i>
    </button>
    <button disabled={activo || factura.pagado}
        class:btn-lg={$breakpoint === 'xxl'}
        class:btn-md={$breakpoint !== 'xxl'}
        class='btn btn-info' on:click={checkAll}>
            <i 
            class:bi-check-square={checkButton === true}
            class:bi-square={checkButton === false}
            class="bi"></i>
    </button>

    <div class="float-end">
        <button disabled={activo || factura.pagado}
            class:btn-lg={$breakpoint === 'xxl'}
            class:btn-md={$breakpoint !== 'xxl'}        
            class='btn btn-success' data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight"><i class="bi bi-cart-plus-fill"></i>
        </button>
        <button 
            class:btn-lg={$breakpoint === 'xxl'}
            class:btn-md={$breakpoint !== 'xxl'}        
            disabled={ !Boolean(Number(countSelected)) || activo  || factura.pagado} class='btn btn-danger' on:click={deleteSelected}><i class="bi bi-cart-dash-fill"></i><span class="badge bg-light text-danger ms-2 ps-1 pe-1">{countSelected}</span>
        </button>
    </div>
</div>

<div class="offcanvas offcanvas-end" style='width:700px;' bind:this={offcanvas} tabindex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
    <div class="offcanvas-header">
      <h5 id="offcanvasRightLabel">Productos Favoritos</h5>
      <button type="button" bind:this={offcanvasClose} class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    </div>
    <div class="offcanvas-body pt-0">
        <div class='d-flex flex-wrap'>
            {#each productosFavoritos as item,index}
                    <BotonCaja on:click={()=>addProductoFavorito(index)} width='166px' id={item.id} image={item.image} color={item.color} precio={item.precio}>{item.nombre}</BotonCaja>
            {:else}
                    <p class='text-danger'>No hay productos favoritos</p>
            {/each}
        </div>
    </div>
</div>

<div class='scroll'
class:activo={cliente.activo === true}
class:noactivo={cliente.activo === false}
>
    <div class="tableFixHead">
        <table>
            <thead>
                <tr>
                    <th style='width:20px;' class='text-center'>&nbsp;</th>
                    <th style='width:120px;'>CÓDIGO</th>
                    <th style='width:70px;'>CANTIDAD</th>
                    <th>DESCRIPCIÓN</th>
                    <th style='width:100px;' class='text-end'>PRECIO</th>
                    <th style='width:100px;' class='text-end'>DESCUENTO</th>
                    <th style='width:100px;' class='text-end'>TOTAL</th>                
                </tr>

            </thead>
            <tbody>
                {#each factura.carrito as item,index}
                    <tr id='registro{index}' 
                    class:bg-gris={factura.carrito[index].lock===true}
                    class:bg-white={factura.carrito[index].lock===false}
                    >
                        <td>
                            <div class="form-check">
                               
                                <input 
                                    class:big-checkbox-xl={$breakpoint === 'xxl'}
                                    class:big-checkbox={$breakpoint !== 'xxl'}                                 
                                    disabled={activo || factura.pagado} class="form-check-input big-checkbox" type="checkbox" on:input={()=>selecIndex(index)} bind:checked={factura.carrito[index].selected}>
                            </div>                            
                        </td>
                        <td class='p-0'>
                            {#if factura.carrito[index].lock===true}
                                <span class='ms-1'>{factura.carrito[index].codigo}</span>
                            {:else}
                                <!-- svelte-ignore a11y-autofocus -->
                                <input type="text" class='inputProduct' on:keypress|self={(e)=>handleKeydown(e,'codigo',index)} bind:value={factura.carrito[index].codigo} autofocus>
                            {/if}
                            
                        </td>
                        <td class='p-0'>
                            <input type="number" disabled={activo || factura.pagado} min="1" class='inputProduct' on:keypress|self={(e)=>handleKeydown(e,'cantidad',index)} bind:value={factura.carrito[index].cantidad} on:input={()=>changeCantidad(index)}>
                        </td>
                        <td>
                            {@html item.descripcion}
                        </td>
                        {#if item.editable=='1'}
                            <td class='p-0'>
                                <input type="number" disabled={activo || factura.pagado} 
                                    min="1.00"
                                    step="0.01"
                                    class='inputProduct' 
                                    on:keypress|self={(e)=>handleKeydown(e,'precio',index)} 
                                    bind:value={factura.carrito[index].precio} 
                                    on:input={()=>changeCantidad(index)}
                                    >
                            </td>
                        {:else}
                            <td class='text-end'>{moneda(item.precio, 'Q.')} </td>
                            <!-- {item.editable} -->
                        {/if}

                        {#if aplicar_descuento===true}
                            <td class='p-0'>
                                <input type="number" disabled={activo || factura.pagado} 
                                    min="1.00"
                                    step="0.01"
                                    class='inputProduct' 
                                    bind:value={factura.carrito[index].descuento} 
                                    on:keypress|self={(e)=>handleKeydown(e,'descuento',index)} 
                                    on:input={()=>changeCantidad(index)}
                                    >
                            </td>
                        {:else}
                            <td class='text-end'>{moneda4(item.descuento, 'Q.')}</td>
                        {/if}
                        

                        <td class='text-end'>{moneda4(item.total, 'Q.')}</td>
                    </tr>
                {:else}
                    <tr>
                        <td colspan='7'><span class='text-danger fw-bold'>SIN PRODUCTOS</span></td>
                    </tr>
                {/each}
            </tbody>
        </table>
    </div>    
</div>

<style>
    .noactivo {
        /*height:600px;*/
        height:540px;
    }
    .activo {
        /*height:375px;*/
        height:315px;
    }
    .scroll {
        overflow-x: hidden;
        overflow-y: scroll;
    }
    .tableFixHead          { overflow: auto; height: 100%; }
    .tableFixHead thead th { position: sticky; top: 0; z-index: 1; }

    /* Just common table stuff. Really. */
    table  { border-collapse: collapse; width: 99%; }
    td { 
        font-size:0.8em;
        padding:4px;
        padding-right:10px;
        /*background-color: #eee;*/
        border-bottom:1px solid #aaa;
        border-right:1px solid #aaa;

    }
    th     { 
                background:#eee;
                font-size:0.7em;
                background:#212529;
                color:#fff;
                padding:4px;
           } 
    .big-checkbox {width: 20px; height: 20px;}
    .big-checkbox-xl {width: 30px; height: 30px;}
    .big-checkbox2 {width: 15px; height: 15px;}  
    .inputProduct {
        border:0px;
        border-radius: 0px;
        height:37px;
        width:98%;
    }
    .bg-gris {
        background-color:#eee;
    }
</style>